import ForgetPasswordContainer from "../../Componant/Authentication/ForgetPassword";

const ForgetPassword = () => {
  return (
    <div className="page-wrapper">
      <ForgetPasswordContainer />
    </div>
  );
};

export default ForgetPassword;
